import React, { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";
import step1 from "../../assets/images/step1.png";
import step2 from "../../assets/images/step2.png";
import step3 from "../../assets/images/step3.png";

const imageMap = {
    1: step1,
    2: step2,
    3: step3
}
const Training =()=>{
    const [step, setStep] = useState(1);
    return <div className={styles.modal_wrap}>
        <div onClick={()=>{setStep(step - 1)}} className={styles.arrow_icon}>{step> 1 &&<LeftOutlined />}</div>   
        <div>
            <div className={styles.inst_title}><span>{`Step ${step}:`}</span> <span>Follow below steps to create a menu</span></div>
            <div>
            <img
                alt="text"
                className={styles.menu_img}
                style={{height: 450}}
                src={imageMap[step]}
            />
            </div>
        </div>
        <div onClick={()=>{setStep(step + 1)}} className={styles.arrow_icon}>{step <3 && <RightOutlined />}</div>
    </div>
};
export default Training;
